import React from "react";
import Footer from "../Footer/Footer";
import Home from "../Home/Home";

const About = () => {
  return (
    <div>
     <Home/>
      <Footer />
    </div>
  );
};

export default About;
